const license = {
    not_installed: 'ยังไม่ได้ติดตั้งไลเซนส์บนอินสแตนซ์นี้',
    invalid_key: 'คีย์ไลเซนส์ไม่ถูกต้องหรือถูกแก้ไข',
    expired_key: 'คีย์ไลเซนส์หมดอายุแล้ว กรุณารับคีย์ใหม่และติดตั้งอีกครั้ง',
};
export default Object.freeze(license);
